var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02575 1.76775C2.28117 1.39566 1.457 2.10608 1.71492 2.89733L3.38742 8.02441C3.43472 8.16926 3.52083 8.29836 3.63639 8.39768C3.75195 8.49701 3.89252 8.56274 4.04283 8.58775L10.6512 9.689C10.9991 9.74733 10.9991 10.2473 10.6512 10.3057L4.04325 11.4069C3.89294 11.4319 3.75236 11.4977 3.63681 11.597C3.52125 11.6963 3.43514 11.8254 3.38783 11.9702L1.71492 17.1002C1.45658 17.8919 2.28117 18.6023 3.02575 18.2302L17.8149 10.8377C18.5062 10.4919 18.5062 9.50566 17.8149 9.16025L3.02575 1.76775Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic-send.64c281803ade1e81d22f67a810c18f07.svg";
export { ForwardRef as ReactComponent };